export class OrganizationRolesEnum {


    static readonly ROLE_OWNER = "owner";
    static readonly ROLE_ADMIN = "admin";
    static readonly ROLE_BILLING = "billing";
    static readonly ROLE_MEMBER = "member";

}